import { useEffect, useState } from 'react';
import { AsideNavigationItem } from '../molecules/AsideNavigationItem';
import { AsideNavigationSection } from '../molecules/AsideNavigationSection';
import useMobileView from '../../../hooks/useMobileView';

export interface AsideNavigationItemType {
	Id: number;
	DisplayName: string;
	Expanded: boolean;
	IsAnchor: boolean;
	Url: string;
	Children: AsideNavigationItemType[];
}

export interface AsideNavigationBlockProps {
	naviData: AsideNavigationItemType | null;
}

export const AsideNavigationBlock = ({
	naviData,
}: AsideNavigationBlockProps) => {
	const isMobile = useMobileView(768);
	const isTablet = useMobileView(900);
	const showMobileNavi = isMobile || isTablet;
	const [naviBlockIsOpen, setNaviBlockIsOpen] = useState(false);

	const containerClassNames = `sticky ${showMobileNavi ?'opacity-100' : ''} ${isMobile ? 'top-[55px]' : isTablet ? 'top-[72px]' : 'top-24'} relative z-20`;
	const navBlockClassNames = `min-w-[260px] ${showMobileNavi ? 'bg-cream' : 'bg-lightCream'} ${showMobileNavi ? '' : 'rounded-sm'} z-10 ${showMobileNavi ? 'max-h-[85vh] overflow-y-auto' : ''}`;
	const navListClassNames = `${showMobileNavi && naviBlockIsOpen ? 'border-b-[5px] border-secondary-yellow' : ''} ${showMobileNavi ? 'divide-y divide-white' : ''}`;
	const bgElClassNames =
		'absolute inset-x-0 top-full bg-primary-teal h-[100vh] opacity-90';

	useEffect(() => {
		if (showMobileNavi && naviBlockIsOpen) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = '';
		}
	}, [showMobileNavi, naviBlockIsOpen]);

	if (!naviData) return null;

	return (
		<div className={containerClassNames}>
			<nav className={navBlockClassNames}>
				<ul className={navListClassNames}>
					<AsideNavigationItem
						item={naviData}
						naviBlockIsOpen={naviBlockIsOpen}
						setNaviBlockIsOpen={setNaviBlockIsOpen}
					/>
					{naviData.Children.map((item, index) => (
						<AsideNavigationSection
							key={`AsideNavigationLevel - ${index}}`}
							item={item}
							inheritNaviLevel={0}
							naviBlockIsOpen={naviBlockIsOpen}
						/>
					))}
				</ul>
				{showMobileNavi && naviBlockIsOpen && (
					<div
						className={bgElClassNames}
						onClick={() => setNaviBlockIsOpen(false)}
					/>
				)}
			</nav>
		</div>
	);
};
